import { useNavigate } from 'react-router-dom';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DefaultButton } from '~/components/atomic';
import { PAGE_ROUTE } from '~/constants';

export default function NoChatListMessage() {
  const navigate = useNavigate();

  return (
    <Container>
      <Description>
        There are no chats. <br /> Explore characters and start a chat.
      </Description>
      <ButtonBox>
        <DefaultButton onClick={() => navigate(PAGE_ROUTE.EXPLORE)}>
          Explore characters
        </DefaultButton>
      </ButtonBox>
    </Container>
  );
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  width: 100%;
  height: 300px;
`;

export const Description = styled.p`
  ${({ theme }) => css`
    display: block;
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.text.body16_medium}
    text-align: center;
  `}
`;

export const ButtonBox = styled.div`
  display: block;
`;

export const Button = styled.button`
  ${({ theme }) => css`
    display: block;
    width: 196px;
    height: 44px;
    border-radius: 22px;
    background: ${theme.themeColor.main_1};
    color: ${theme.content.content_dark_1};
    ${theme.fontStyle.title.section18_medium}
  `}
`;
